exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-pano{width:100%;height:100%;margin:0;padding:0;border:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7974fb6b","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Pano.vue
// module id = 134
// module chunks = 1